module.exports = __webpack_public_path__ + "c5aaa44ab1786e11cf5f6fec2b19db0b.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_2_a.png
// module id = 158
// module chunks = 0